import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL + "/api/EmpSalary";

export function getCurrSalary() {
  return http.post(`${apiEndpoint}/GetCurrent`);
}
